import { Component } from 'react';
class SocialLinksField extends Component {
  render() {
    return null;
  }
}
export default SocialLinksField;